import { render, staticRenderFns } from "./CreateTopicPage.vue?vue&type=template&id=3605a5de"
import script from "./CreateTopicPage.vue?vue&type=script&lang=js"
export * from "./CreateTopicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports